import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=6f57a9ce&scoped=true&"
import script from "./FooterBlock.vue?vue&type=script&lang=ts&"
export * from "./FooterBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=6f57a9ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57a9ce",
  null
  
)

export default component.exports